import { Validator } from "./types";
import { SearchContextType } from "../search-context";
import ValidationErrorMessages from "./error-messages";

const validateNISearch: Validator = (data: SearchContextType) => {
  const {
    nationalInsuranceNumber,
    firstName,
    middleNames,
    lastName,
    dateOfBirth,
  } = data;

  const hasNI = !!nationalInsuranceNumber?.trim();
  const hasAnyOtherValue =
    !!firstName?.trim() ||
    !!middleNames?.trim() ||
    !!lastName?.trim() ||
    !!dateOfBirth?.toString().trim();

  const isNIOnlySearch = hasNI && !hasAnyOtherValue;

  if (!hasNI) {
    return { isValid: false, errors: [] };
  }

  return isNIOnlySearch
    ? { isValid: true, errors: [] }
    : { isValid: false, errors: [ValidationErrorMessages.invalidNI] };
};

export default validateNISearch;
